import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { formatarValorMonetario } from "../../../../../helpers/masks";
import PaperDraggable from "../../../../../components/PaperDraggable";
import { useMemo } from "react";
import { Parcelas } from "../../../../../types/api/fiscal/detalhe-nfe-entrada";
import moment from "moment";

export default function DialogDetalheParcelasNF({
    open,
    onClose,
    parcelas
}: DialogDetalheParcelasNFProps) {


    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title"><b>Parcelas</b></DialogTitle>
            <DialogContent>
                <TableContainer sx={{ border: "1px solid #ccc", borderRadius: 2 }}>
                    <Table size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell><b>Parcela</b></TableCell>
                                <TableCell align="right"><b>Vencimento</b></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>

                            {
                                parcelas.duplicatas.map((item, index) => {
                                    return (
                                        <TableRow
                                            key={index}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row">
                                                {`${index + 1}ª ${formatarValorMonetario(item.valor)}`}
                                            </TableCell>
                                            <TableCell sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "flex-end",
                                                alignItems: "center",
                                                gap: 0.5
                                            }}
                                            >
                                                {moment(item.vencimento).format('DD/MM/YYYY')}
                                            </TableCell>
                                        </TableRow>
                                    )
                                })
                            }

                            <TableRow
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">
                                    <b>Valor total</b>
                                </TableCell>
                                <TableCell align="right"><b>{formatarValorMonetario(parcelas.fatura.valor_liquido)}</b></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    )
}


interface DialogDetalheParcelasNFProps {
    open: boolean;
    onClose: () => void;
    parcelas: Parcelas
}

type TParcela = {
    fatura: {
        numero: string;
        valor_original: number;
        valor_desconto: number;
        valor_liquido: number;
    };
    duplicatas: {
        numero: string;
        vencimento: string;
        valor: number;
    }[];
}
